import { TriangleAlertIcon } from 'lucide-react';

interface Props {
    className?: string;
}

export const WarningIcon = TriangleAlertIcon;
